// Generated by ts-to-zod
import { z } from 'zod';

const automationBlockerBaseSchema = z.object({
  occurrences: z.number(),
  documentOccurrences: z.number(),
  documentOccurrencesRel: z.number(),
  id: z.string().nullable(),
});

const annotationAutomationBlockerSchema = automationBlockerBaseSchema.and(
  z.object({
    level: z.literal('annotation'),
    type: z.string(),
  })
);

const datapointAutomationBlockerSchema = automationBlockerBaseSchema.and(
  z.object({
    level: z.literal('datapoint'),
    id: z.string(),
    type: z.string(),
  })
);

export const automationResponseAutomationBlockerSchema = z.union([
  annotationAutomationBlockerSchema,
  datapointAutomationBlockerSchema,
]);
